"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_ACCUMULATION_THRESHOLDS = void 0;
exports.NO_ACCUMULATION_THRESHOLDS = {
    totalKg: null,
    nonAcuteKg: null,
    acuteKg: null,
};
//# sourceMappingURL=onSiteAccumulationThresholds.js.map